import DashboardPage from "./Dashboard.tsx";
import AgentSmithActionBriefs from "./AgentSmithActionBriefs";

function DashboardRouteProxy(props) {
  const path = window.location.pathname;

  if (path === "/admin/action-briefs" || path === "/admin/onboarding/action-briefs") {
    return <AgentSmithActionBriefs session={props.session} />;
  }

  return <DashboardPage {...props} />;
}

export default DashboardRouteProxy;
